// @flow

import React from 'react';
import styled, { css } from 'styled-components';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { ifProp } from 'styled-tools';

import Link from '../../components/Link';

type Props = {
  filters?: boolean,
};

const Wrapper = styled.p`
  font-size: 1.1em;
  color: #3c4042;

  a {
    font-weight: bold;

    &:not(:active) {
      color: #4183c4;
    }
  }

  ${ifProp(
    'small',
    css`
      font-size: 0.8em;
    `,
  )};
`;

const Item = styled(Link)`
  font-size: 13px;
  line-height: 18px;
  display: block;
  font-weight: bold;
  color: rgb(65, 131, 196) !important;
`;

const ProAccountRequired = (props: Props) => {
  const currentPath = window.location.pathname;
  const buttonLocation = currentPath.includes('queries') ? 'queries' : 'trends';

  if (props.filters) {
    return (
      <Wrapper small>
        <FormattedHTMLMessage
          id="common.proRequiredFilters"
          defaultMessage="<strong>Внимание!</strong> Данные, приведенные ниже, показываются с опозданием в 30 дней. Для того, чтобы увидеть актуальную статистику, необходимо быть подписчиком"
        />{' '}
        <Link to="/tariffs/">
          <Item
            onClick={() => {
              (window.dataLayer || []).push({
                event: 'business_activate',
                action: 'start',
                location: 'business_999',
                button_location: buttonLocation,
              });
            }}
          >
            999 Business
          </Item>
        </Link>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <FormattedMessage
        id="common.proRequired"
        defaultMessage="Данная опция доступна только для подписчиков"
      />{' '}
      <Link to="/tariffs/">999 Business</Link>
    </Wrapper>
  );
};

export default ProAccountRequired;



// WEBPACK FOOTER //
// ./src/buisness/ProAccountRequired/index.js